import { Injectable, inject, signal, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { ELocalStorage } from '../enums/ELocalStorage';
import { ThemeMode } from '../enums/types';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  currentTheme = signal<ThemeMode>('light');

  init(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    // The site uses a single light theme (matches the design). Always render
    // light and clear any previously-stored dark preference so the app never
    // gets stuck in dark mode now that the theme toggle has been removed.
    localStorage.removeItem(ELocalStorage.THEME);
    this.setTheme('light');
  }

  toggleTheme(): void {
    const newTheme: ThemeMode = this.currentTheme() === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(ELocalStorage.THEME, newTheme);
    }
  }

  setTheme(theme: ThemeMode): void {
    this.currentTheme.set(theme);
    if (isPlatformBrowser(this.platformId)) {
      const htmlEl = this.document.documentElement;
      if (theme === 'dark') {
        htmlEl.classList.add('dark');
      } else {
        htmlEl.classList.remove('dark');
      }
    }
  }

  isDark(): boolean {
    return this.currentTheme() === 'dark';
  }
}
